import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { 
  AccountIcon, 
  ShieldCheckIcon,
  StarIcon,
  ClockIcon
} from '../../components/icons';

const SuperAdminProfile: React.FC = () => {
  const { currentUser, requestNotificationPermission, notificationPermission, logout } = useAuth();
  const [isRequesting, setIsRequesting] = useState(false);

  const handleNotificationToggle = async () => {
    setIsRequesting(true);
    try {
      const result = await requestNotificationPermission();
      if (result === 'granted') {
        alert("Notifications activées avec succès !");
      } else {
        alert("Les notifications n'ont pas pu être activées. Vérifiez les réglages de votre navigateur.");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsRequesting(false);
    }
  };

  if (!currentUser) return null;

  return (
    <div className="min-h-screen bg-gray-50 p-6 pb-24">
      <h1 className="text-2xl font-black text-gray-900 mb-8 flex items-center gap-2">
        <AccountIcon className="w-8 h-8 text-black" />
        Mon Profil Admin
      </h1>
      
      {/* Profile Header */}
      <div className="bg-red-600 p-8 rounded-[40px] text-white shadow-xl shadow-red-100 mb-8 relative overflow-hidden">
         <div className="relative z-10 text-left">
           <p className="text-red-100 font-bold uppercase tracking-widest text-[10px] mb-1">Super Administrateur</p>
           <h2 className="text-3xl font-black mb-2">{currentUser.name}</h2>
           <p className="text-red-200 font-medium text-sm">{currentUser.email}</p>
         </div>
         <div className="absolute right-[-20px] bottom-[-20px] opacity-10 rotate-12">
            <StarIcon className="w-48 h-48" />
         </div>
      </div>

      {/* Settings Sections */}
      <div className="space-y-6">
        {/* Notifications Section */}
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-50 text-left">
           <h3 className="font-black text-gray-900 mb-4 flex items-center gap-2">
             <ShieldCheckIcon className="w-5 h-5 text-blue-500" />
             Sécurité & Notifications
           </h3>
           <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl">
              <div>
                <p className="font-bold text-gray-900 text-sm">Notifications Push</p>
                <p className="text-[10px] text-gray-500 font-medium">Alerté en cas de nouvelle inscription ou paiement</p>
              </div>
              <button 
                onClick={handleNotificationToggle}
                disabled={isRequesting || notificationPermission === 'granted'}
                className={`w-14 h-8 rounded-full transition-all flex items-center p-1 ${
                  notificationPermission === 'granted' ? 'bg-green-500 justify-end' : 'bg-gray-200 justify-start'
                }`}
              >
                 <div className="w-6 h-6 bg-white rounded-full shadow-md" />
              </button>
           </div>
           {notificationPermission === 'granted' ? (
             <p className="text-[10px] text-green-600 font-bold mt-2 px-2">✓ Notifications actives sur cet appareil</p>
           ) : (
             <p className="text-[10px] text-orange-600 font-bold mt-2 px-2">! Notifications désactivées</p>
           )}
        </div>

        {/* Info Section */}
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-50 text-left">
           <h3 className="font-black text-gray-900 mb-4 flex items-center gap-2">
             <ClockIcon className="w-5 h-5 text-purple-500" />
             Informations Techniques
           </h3>
           <div className="space-y-4">
              <div className="flex justify-between items-center px-2">
                 <span className="text-gray-400 text-xs font-bold uppercase tracking-widest">Version App</span>
                 <span className="font-black text-gray-900 text-sm tracking-widest">1.5.8</span>
              </div>
              <div className="flex justify-between items-center px-2">
                 <span className="text-gray-400 text-xs font-bold uppercase tracking-widest">UID Admin</span>
                 <span className="font-mono text-gray-400 text-[10px]">{currentUser.uid}</span>
              </div>
           </div>
        </div>

        {/* Global Action Section */}
        <button 
          onClick={logout}
          className="w-full py-5 bg-white text-red-600 border border-red-500/10 rounded-3xl shadow-sm font-black uppercase text-sm tracking-widest hover:bg-red-50 transition-all active:scale-95"
        >
          Déconnexion Sécurisée
        </button>
      </div>
    </div>
  );
};

export default SuperAdminProfile;
